function NavButton({
  isActive,
  onClick,
  id,
  controls,
  title,
  description,
  children
}) {
  const baseClasses = "w-full flex md:flex-col text-start hover:outline p-3 md:p-5 rounded-xl transition";
  const activeClasses = "outline hs-tab-active:bg-white shadow-lg active";
  const inactiveClasses = "bg-white";

  return (
    <button
      type="button"
      className={`${baseClasses} ${isActive ? activeClasses : inactiveClasses}`}
      id={id}
      data-hs-tab={`#${controls}`}
      aria-controls={controls}
      role="tab"
      aria-selected={isActive}
      onClick={onClick}
    >
      <div className="hidden md:inline-flex justify-center items-center size-[62px] rounded-full border-4 border-gray-100 hs-tab-active:border-blue-600 hs-tab-active:bg-blue-50">
        {children}
      </div>
      <div className="md:hidden inline-flex justify-center items-center size-[24px]">
        &raquo;
      </div>
      <span className="md:mt-5">
        <span className="hs-tab-active:text-blue-600 block font-bold text-gray-800">
          {title}
        </span>
        <span className="hidden lg:block mt-2 text-gray-800">
          {description}
        </span>
      </span>
    </button>
  );
}

export default NavButton;
